// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2bM5O","choiceBoxes":"toolbarselects_choiceBoxes__3QCtt","simpleField":"toolbarselects_simpleField__1n71T"};